/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CandidateCompany model module.
 * @module model/CandidateCompany
 * @version v1
 */
class CandidateCompany {
    /**
     * Constructs a new <code>CandidateCompany</code>.
     * Empresa vista por el candidato [P_A_31]
     * @alias module:model/CandidateCompany
     */
    constructor() { 
        
        CandidateCompany.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateCompany</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateCompany} obj Optional instance to populate.
     * @return {module:model/CandidateCompany} The populated <code>CandidateCompany</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateCompany();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('sector')) {
                obj['sector'] = ApiClient.convertToType(data['sector'], 'String');
            }
            if (data.hasOwnProperty('subtitle')) {
                obj['subtitle'] = ApiClient.convertToType(data['subtitle'], 'String');
            }
            if (data.hasOwnProperty('logo')) {
                obj['logo'] = ApiClient.convertToType(data['logo'], 'String');
            }
            if (data.hasOwnProperty('web')) {
                obj['web'] = ApiClient.convertToType(data['web'], 'String');
            }
            if (data.hasOwnProperty('location')) {
                obj['location'] = ApiClient.convertToType(data['location'], 'String');
            }
            if (data.hasOwnProperty('text')) {
                obj['text'] = ApiClient.convertToType(data['text'], 'String');
            }
            if (data.hasOwnProperty('empleados')) {
                obj['empleados'] = ApiClient.convertToType(data['empleados'], 'Number');
            }
            if (data.hasOwnProperty('video')) {
                obj['video'] = ApiClient.convertToType(data['video'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
CandidateCompany.prototype['id'] = undefined;

/**
 * @member {String} name
 */
CandidateCompany.prototype['name'] = undefined;

/**
 * @member {String} sector
 */
CandidateCompany.prototype['sector'] = undefined;

/**
 * Texto libre corto
 * @member {String} subtitle
 */
CandidateCompany.prototype['subtitle'] = undefined;

/**
 * url final para hacer get
 * @member {String} logo
 */
CandidateCompany.prototype['logo'] = undefined;

/**
 * @member {String} web
 */
CandidateCompany.prototype['web'] = undefined;

/**
 * Texto libre corto
 * @member {String} location
 */
CandidateCompany.prototype['location'] = undefined;

/**
 * Texto libre largo
 * @member {String} text
 */
CandidateCompany.prototype['text'] = undefined;

/**
 * @member {Number} empleados
 */
CandidateCompany.prototype['empleados'] = undefined;

/**
 * Url de youtube
 * @member {String} video
 */
CandidateCompany.prototype['video'] = undefined;






export default CandidateCompany;

